import React from "react";
import Card from "react-bootstrap/Card";

import Button from "react-bootstrap/Button";
import { AiTwotoneClockCircle } from "react-icons/ai";
function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote">
          <p style={{ margin: "0" }}>
            <span className="purple" style={{ fontSize: "30px" }}>3</span>  months duration, Web development; <br></br> Let's discuss it over a call or coffee
            <br />
            <br />
            <Button variant="primary" href="https://www.freelancer.in/u/nishant2312" target="_blank">

              <AiTwotoneClockCircle /> &nbsp;Hire me
            </Button>
          </p>


        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
